export default {
  name: "pkJs",
  data() {
    return {
      pkData: ""
    }
  },
  created() {
    this.pkEventHub();
  },
  methods: {
    pkEventHub() {
      this.$root.eventHub.$on("pkMatchingResult", ({datas,anim}) => {
        if (!datas.data.adversary_small_id) return;
        this.closeOtherAlert();
        if (anim) {
          datas.data.state = 'matching'
          this.pkData = datas.data;
          setTimeout(() => {
            this.pkData.state = 'matched'
          }, 1900)
        } else {
          datas.data.state = 'matched'
          this.pkData = datas.data;
        }
      })
      this.$root.eventHub.$on("pkScoringResult", (datas) => {
        if (!datas.data.adversary_small_id) return;
        datas.data.state = 'info'
        this.pkData = datas.data;
      })
      this.$root.eventHub.$on("pkResult", (datas) => {
        if (!datas.data.adversary_small_id) return;
        this.closeOtherAlert();
        datas.data.state = 'result'
        this.pkData = datas.data;
      })
    },
  },
  beforeDestroy() {
    this.$root.eventHub.$off("pkMatchingResult");
    this.$root.eventHub.$off("pkScoringResult");
    this.$root.eventHub.$off("pkResult");
  }
}



// WEBPACK FOOTER //
// ./src/components/bussiness/video/pk/pk.js